module.exports = __webpack_public_path__ + "static/img/logo-app-movil.14c85d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-app-movil.png
// module id = 9CrF
// module chunks = 9